export default Object.freeze([
  "#0074E0",
  "#E742A1",
  "#D87D30",
  "#FFDB45",
  "#00C98D",
]);
